define(['swiper_new'], function (Swiper) {
    const swiperProductGallery = new Swiper('.swiper-product', {
        init: false,
        slidesPerView: 'auto',
        edgeSwipeDetection: 'prevent',
        grabCursor: true,
        autoHeight: true,
        observer: true,
        observeParents: true,
        mousewheel: {
            forceToAxis: true,
            thresholdDelta: 10,
            releaseOnEdges: true,
        },
        cssMode: false,
        noSwipingClass: 'print-hovering',
        scrollbar: {
            el: '.swiper-product-scrollbar',
            draggable: true,
        },
        navigation: {
            nextEl: '.swiper-product-button-next',
            prevEl: '.swiper-product-button-prev',
        },
        pagination: {
            el: '.swiper-product-pagination',
            type: 'fraction',
        },
        zoom: {
            toggle: true,
            maxRatio: 2,
        },
    });
    return swiperProductGallery;
});
